import styled from 'styled-components';

const TableName = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export { TableName };
